/** Esqueleto PGC (NPGC) de Ape_Estructura_Balance. Títulos oficiales en español. */
export const BALANCE_NPGC_ESTRUCTURA = [
  { codigo: "AA", titulo: "A) ACTIVO NO CORRIENTE" },
  { codigo: "AA.01", titulo: "I. Inmovilizado intangible" },
  { codigo: "AA.01.1", titulo: "1. Desarrollo" },
  { codigo: "AA.01.2", titulo: "2. Concesiones" },
  { codigo: "AA.01.3", titulo: "3. Patentes, licencias, marcas y similares" },
  { codigo: "AA.01.4", titulo: "4. Fondo de comercio" },
  { codigo: "AA.01.5", titulo: "5. Aplicaciones informáticas" },
  { codigo: "AA.01.6", titulo: "6. Investigación" },
  { codigo: "AA.01.7", titulo: "7. Otro inmovilizado intangible" },
  { codigo: "AA.02", titulo: "II. Inmovilizado material" },
  { codigo: "AA.02.1", titulo: "1. Terrenos y construcciones" },
  {
    codigo: "AA.02.2",
    titulo: "2. Instalaciones técnicas y otro inmovilizado material",
  },
  { codigo: "AA.02.3", titulo: "3. Inmovilizado en curso y anticipos" },
  { codigo: "AA.03", titulo: "III. Inversiones inmobiliarias" },
  { codigo: "AA.03.1", titulo: "1. Terrenos" },
  { codigo: "AA.03.2", titulo: "2. Construcciones" },
  {
    codigo: "AA.04",
    titulo: "IV. Inversiones en empresas del grupo y asociadas a largo plazo",
  },
  { codigo: "AA.04.1", titulo: "1. Instrumentos de patrimonio" },
  { codigo: "AA.04.2", titulo: "2. Créditos a empresas" },
  { codigo: "AA.04.3", titulo: "3. Valores representativos de deuda" },
  { codigo: "AA.04.4", titulo: "4. Derivados" },
  { codigo: "AA.04.5", titulo: "5. Otros activos financieros" },
  { codigo: "AA.04.6", titulo: "6. Otras inversiones" },
  { codigo: "AA.05", titulo: "V. Inversiones financieras a largo plazo" },
  { codigo: "AA.05.1", titulo: "1. Instrumentos de patrimonio" },
  { codigo: "AA.05.2", titulo: "2. Créditos a terceros" },
  { codigo: "AA.05.3", titulo: "3. Valores representativos de deuda" },
  { codigo: "AA.05.4", titulo: "4. Derivados" },
  { codigo: "AA.05.5", titulo: "5. Otros activos financieros" },
  { codigo: "AA.05.6", titulo: "6. Otras inversiones" },
  { codigo: "AA.06", titulo: "VI. Activos por impuesto diferido" },
  { codigo: "AA.07", titulo: "VII. Deudas comerciales no corrientes" },
  { codigo: "AB", titulo: "B) ACTIVO CORRIENTE" },
  {
    codigo: "AB.01",
    titulo: "I. Activos no corrientes mantenidos para la venta",
  },
  { codigo: "AB.02", titulo: "II. Existencias" },
  { codigo: "AB.02.1", titulo: "1. Comerciales" },
  {
    codigo: "AB.02.2",
    titulo: "2. Materias primas y otros aprovisionamientos",
  },
  { codigo: "AB.02.3", titulo: "3. Productos en curso" },
  { codigo: "AB.02.3.1", titulo: "a) De ciclo largo de producción" },
  { codigo: "AB.02.3.2", titulo: "b) De ciclo corto de producción" },
  { codigo: "AB.02.4", titulo: "4. Productos terminados" },
  { codigo: "AB.02.4.1", titulo: "a) De ciclo largo de producción" },
  { codigo: "AB.02.4.2", titulo: "b) De ciclo corto de producción" },
  {
    codigo: "AB.02.5",
    titulo: "5. Subproductos, residuos y materiales recuperados",
  },
  { codigo: "AB.02.6", titulo: "6. Anticipos a proveedores" },
  {
    codigo: "AB.03",
    titulo: "III. Deudores comerciales y otras cuentas a cobrar",
  },
  {
    codigo: "AB.03.1",
    titulo: "1. Clientes por ventas y prestaciones de servicios",
  },
  {
    codigo: "AB.03.1.1",
    titulo: "a) Clientes por ventas y prestaciones de servicios a largo plazo",
  },
  {
    codigo: "AB.03.1.2",
    titulo: "b) Clientes por ventas y prestaciones de servicios a corto plazo",
  },
  { codigo: "AB.03.2", titulo: "2. Clientes, empresas del grupo y asociadas" },
  { codigo: "AB.03.3", titulo: "3. Deudores varios" },
  { codigo: "AB.03.4", titulo: "4. Personal" },
  { codigo: "AB.03.5", titulo: "5. Activos por impuesto corriente" },
  {
    codigo: "AB.03.6",
    titulo: "6. Otros créditos con las Administraciones Públicas",
  },
  {
    codigo: "AB.03.7",
    titulo: "7. Accionistas (socios) por desembolsos exigidos",
  },
  {
    codigo: "AB.04",
    titulo: "IV. Inversiones en empresas del grupo y asociadas a corto plazo",
  },
  { codigo: "AB.04.1", titulo: "1. Instrumentos de patrimonio" },
  { codigo: "AB.04.2", titulo: "2. Créditos a empresas" },
  { codigo: "AB.04.3", titulo: "3. Valores representativos de deuda" },
  { codigo: "AB.04.4", titulo: "4. Derivados" },
  { codigo: "AB.04.5", titulo: "5. Otros activos financieros" },
  { codigo: "AB.04.6", titulo: "6. Otras inversiones" },
  { codigo: "AB.05", titulo: "V. Inversiones financieras a corto plazo" },
  { codigo: "AB.05.1", titulo: "1. Instrumentos de patrimonio" },
  { codigo: "AB.05.2", titulo: "2. Créditos a empresas" },
  { codigo: "AB.05.3", titulo: "3. Valores representativos de deuda" },
  { codigo: "AB.05.4", titulo: "4. Derivados" },
  { codigo: "AB.05.5", titulo: "5. Otros activos financieros" },
  { codigo: "AB.05.6", titulo: "6. Otras inversiones" },
  { codigo: "AB.06", titulo: "VI. Periodificaciones a corto plazo" },
  {
    codigo: "AB.07",
    titulo: "VII. Efectivo y otros activos líquidos equivalentes",
  },
  { codigo: "AB.07.1", titulo: "1. Tesorería" },
  { codigo: "AB.07.2", titulo: "2. Otros activos líquidos equivalentes" },
  { codigo: "PA", titulo: "A) PATRIMONIO NETO" },
  { codigo: "PA1", titulo: "A-1) Fondos propios" },
  { codigo: "PA1.01", titulo: "I. Capital" },
  { codigo: "PA1.01.1", titulo: "1. Capital escriturado" },
  { codigo: "PA1.01.2", titulo: "2. (Capital no exigido)" },
  { codigo: "PA1.02", titulo: "II. Prima de emisión" },
  { codigo: "PA1.03", titulo: "III. Reservas" },
  { codigo: "PA1.03.1", titulo: "1. Legal y estatutarias" },
  { codigo: "PA1.03.2", titulo: "2. Otras reservas" },
  {
    codigo: "PA1.04",
    titulo: "IV. (Acciones y participaciones en patrimonio propias)",
  },
  { codigo: "PA1.05", titulo: "V. Resultados de ejercicios anteriores" },
  { codigo: "PA1.05.1", titulo: "1. Remanente" },
  {
    codigo: "PA1.05.2",
    titulo: "2. (Resultados negativos de ejercicios anteriores)",
  },
  { codigo: "PA1.06", titulo: "VI. Otras aportaciones de socios" },
  { codigo: "PA1.07", titulo: "VII. Resultado del ejercicio" },
  { codigo: "PA1.08", titulo: "VIII. (Dividendo a cuenta)" },
  { codigo: "PA1.09", titulo: "IX. Otros instrumentos de patrimonio neto" },
  { codigo: "PA2", titulo: "A-2) Ajustes por cambios de valor" },
  {
    codigo: "PA2.01",
    titulo: "I. Activos financieros disponibles para la venta",
  },
  { codigo: "PA2.02", titulo: "II. Operaciones de cobertura" },
  {
    codigo: "PA2.03",
    titulo:
      "III. Activos no corrientes y pasivos vinculados, mantenidos para la venta",
  },
  { codigo: "PA2.04", titulo: "IV. Diferencia de conversión" },
  { codigo: "PA2.05", titulo: "V. Otros" },
  {
    codigo: "PA3",
    titulo: "A-3) Subvenciones, donaciones y legados recibidos",
  },
  { codigo: "PB", titulo: "B) PASIVO NO CORRIENTE" },
  { codigo: "PB.01", titulo: "I. Provisiones a largo plazo" },
  {
    codigo: "PB.01.1",
    titulo: "1. Obligaciones por prestaciones a largo plazo al personal",
  },
  { codigo: "PB.01.2", titulo: "2. Actuaciones medioambientales" },
  { codigo: "PB.01.3", titulo: "3. Provisiones por reestructuración" },
  { codigo: "PB.01.4", titulo: "4. Otras provisiones" },
  { codigo: "PB.02", titulo: "II. Deudas a largo plazo" },
  { codigo: "PB.02.1", titulo: "1. Obligaciones y otros valores negociables" },
  { codigo: "PB.02.2", titulo: "2. Deuda con entidades de crédito" },
  { codigo: "PB.02.3", titulo: "3. Acreedores por arrendamiento financiero" },
  { codigo: "PB.02.4", titulo: "4. Derivados" },
  { codigo: "PB.02.5", titulo: "5. Otros pasivos financieros" },
  {
    codigo: "PB.03",
    titulo: "III. Deudas con empresas del grupo y asociadas a largo plazo",
  },
  { codigo: "PB.04", titulo: "IV. Pasivos por impuesto diferido" },
  { codigo: "PB.05", titulo: "V. Periodificaciones a largo plazo" },
  { codigo: "PB.06", titulo: "VI. Acreedores comerciales no corrientes" },
  {
    codigo: "PB.07",
    titulo: "VII. Deuda con características especiales a largo plazo",
  },
  { codigo: "PC", titulo: "C) PASIVO CORRIENTE" },
  {
    codigo: "PC.01",
    titulo:
      "I. Pasivos vinculados con activos no corrientes mantenidos para la venta",
  },
  { codigo: "PC.02", titulo: "II. Provisiones a corto plazo" },
  { codigo: "PC.03", titulo: "III. Deudas a corto plazo" },
  { codigo: "PC.03.1", titulo: "1. Obligaciones y otros valores negociables" },
  { codigo: "PC.03.2", titulo: "2. Deuda con entidades de crédito" },
  { codigo: "PC.03.3", titulo: "3. Acreedores por arrendamiento financiero" },
  { codigo: "PC.03.4", titulo: "4. Derivados" },
  { codigo: "PC.03.5", titulo: "5. Otros pasivos financieros" },
  {
    codigo: "PC.04",
    titulo: "IV. Deudas con empresas del grupo y asociadas a corto plazo",
  },
  {
    codigo: "PC.05",
    titulo: "V. Acreedores comerciales y otras cuentas a pagar",
  },
  { codigo: "PC.05.1", titulo: "1. Proveedores" },
  { codigo: "PC.05.1.1", titulo: "a) Proveedores a largo plazo" },
  { codigo: "PC.05.1.2", titulo: "b) Proveedores a corto plazo" },
  {
    codigo: "PC.05.2",
    titulo: "2. Proveedores, empresas del grupo y asociadas",
  },
  { codigo: "PC.05.3", titulo: "3. Acreedores varios" },
  {
    codigo: "PC.05.4",
    titulo: "4. Personal (remuneraciones pendientes de pago)",
  },
  { codigo: "PC.05.5", titulo: "5. Pasivos por impuesto corriente" },
  {
    codigo: "PC.05.6",
    titulo: "6. Otras deudas con las Administraciones Públicas",
  },
  { codigo: "PC.05.7", titulo: "7. Anticipos de clientes" },
  { codigo: "PC.06", titulo: "VI. Periodificaciones a corto plazo" },
];

export const BALANCE_KEY_TOTAL_ACTIVO = "TOTAL ACTIVO";
export const BALANCE_KEY_TOTAL_PN_PASIVO = "TOTAL PATRIMONIO NETO Y PASIVO";
export const NML_BALANCE_PATH = "/balance-analitico/nml_spain";

export const isBalanceSectionCodigo = (codigo) =>
  ["AA", "AB", "PA", "PB", "PC"].includes(String(codigo || ""));

export const balanceIndentLevel = (codigo) => {
  const c = String(codigo || "");
  if (isBalanceSectionCodigo(c)) return 0;
  if (/^PA[123]$/.test(c)) return 1;
  return (c.match(/\./g) || []).length;
};

export const isBalanceDescendant = (parent, child) => {
  const p = String(parent || "");
  const c = String(child || "");
  if (!p || !c || p === c) return false;
  if (p === "PA") return c.startsWith("PA");
  return c.startsWith(`${p}.`);
};

export const isActivoCodigo = (codigo) => {
  const c = String(codigo || "");
  return c === "AA" || c === "AB" || c.startsWith("AA.") || c.startsWith("AB.");
};

/** 551: A3 mueve el saldo acreedor a pasivo (PC.03.5), no lo deja en AB.05.5. */
export const BALANCE_CODIGO_OTROS_ACTIVOS_FIN = "AB.05.5";
export const BALANCE_CODIGO_OTROS_PASIVOS_FIN = "PC.03.5";
